import { TableSubAction } from '../../../shared/components/sep-table/Action';
import { CertificateLanguage } from './models/CertificateLanguage';

const LANGUAGE_LABEL_KEYS: Record<CertificateLanguage, string> = {
  [CertificateLanguage.GERMAN]: 'portal.courses.certificates.languages.de',
  [CertificateLanguage.ENGLISH]: 'portal.courses.certificates.languages.en',
};

export function certificateLanguageSubActions<TTarget>(
  exportCertificates: (target: TTarget, language: CertificateLanguage) => void,
): Array<TableSubAction<TTarget>> {
  return Object.values(CertificateLanguage).map((language) => ({
    label: LANGUAGE_LABEL_KEYS[language],
    icon: 'translate',
    translate: true,
    executeAction: (target: TTarget) => {
      exportCertificates(target, language);
    },
  }));
}
